<template>
  <layout />
</template>

<script setup>
import { onMounted } from "vue";
import layout from '@/components/layout.vue'

onMounted(() => {
  document.querySelector('#main-loading').style.display = 'none'
})
</script>

<style lang="scss" scoped>
.admin_box {
  color: red;
}
</style>
